import type { CurrencyCode } from '@noths/polaris-client-localisation';
import { priceFormatter } from '@noths/polaris-client-utils';

import type { ProductFeatureItem } from '../components/ProductFeatures';
import { ProductFeature } from '../components/ProductFeatures';
import { MADE_TO_ORDER_TOOLTIP } from '../copy';

interface GetProductFeatureItemOptions {
  currency: CurrencyCode;
  minimumOptionsCost: number;
}

export const getProductFeatureItem = (
  feature: ProductFeature,
  { currency, minimumOptionsCost }: GetProductFeatureItemOptions,
): ProductFeatureItem | undefined => {
  switch (feature) {
    case ProductFeature.GiftWrappingAvailable:
      return { icon: 'giftAndWrap', label: 'Gift wrapping available' };
    case ProductFeature.FreeGiftWrappingAvailable:
      return { icon: 'giftAndWrap', label: 'Free gift wrapping available' };
    case ProductFeature.PhotoPersonalisation:
      return { icon: 'photoUpload', label: 'Photo personalisation' };
    case ProductFeature.Personalisable:
      return {
        icon: 'personalizable',
        label:
          minimumOptionsCost > 0
            ? `Personalisable from ${priceFormatter(currency, minimumOptionsCost)}`
            : 'Personalisable',
      };
    case ProductFeature.MadeInBritain:
      return { icon: 'madeInUk', label: 'Made in Britain' };
    case ProductFeature.MadeToOrder:
      return { icon: 'madeToOrder', label: 'Made to Order', tooltip: MADE_TO_ORDER_TOOLTIP };
    default: {
      // Forces a compile error if a new ProductFeature is added without a case above.
      const exhaustiveCheck: never = feature;
      void exhaustiveCheck;

      return undefined;
    }
  }
};
